import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import DashboardMockup from '../assets/dashboard_mockup.png';

const Home = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (isAuthenticated) {
    return <Navigate to="/gestionShifts" replace />;
  }
  return (
    <div className="min-h-screen bg-gradient-to-r from-blue-50 to-indigo-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center">
          <h1 className="text-3xl font-extrabold text-gray-900 sm:text-3xl sm:tracking-tight lg:text-3xl">
            Bienvenue sur notre application de gestion de plannings
          </h1>
        </div>
        
        <div className="mt-10 flex justify-center">
          <Link
            to="/login"
            className="px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 md:py-4 md:text-lg md:px-10 transition-colors shadow-lg shadow-indigo-200"
          >
            Se connecter
          </Link>
        </div>

        {/* Mockup Section */}
        <div className="mt-16 relative">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-gray-200 bg-white">
            <div className="absolute top-0 left-0 right-0 h-8 bg-gray-50 border-b border-gray-200 flex items-center px-4 gap-2">
              <div className="w-3 h-3 rounded-full bg-red-400"></div>
              <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
              <div className="w-3 h-3 rounded-full bg-green-400"></div>
            </div>
            <img 
              src={DashboardMockup} 
              alt="Dashboard de gestion des plannings" 
              className="w-full h-auto pt-8"
            />
          </div>
          {/* Decorative blobs */}
          <div className="absolute -top-10 -right-10 w-72 h-72 bg-purple-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob"></div>
          <div className="absolute -bottom-10 -left-10 w-72 h-72 bg-indigo-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000"></div>
        </div>
        
        <div className="mt-20 grid gap-8 md:grid-cols-3">
          {[
            { title: "Planification Intuitive", desc: "Créez et modifiez les plannings en quelques clics grâce au glisser-déposer." },
            { title: "Gestion des Congés", desc: "Validez ou refusez les demandes de vos employés en temps réel." },
            { title: "Suivi des Heures", desc: "Visualisez les quotas horaires et assurez-vous de respecter la législation." }
          ].map((item, idx) => (
            <div key={idx} className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100">
              <div className="text-indigo-600 mb-4 bg-indigo-50 w-12 h-12 rounded-lg flex items-center justify-center">
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-gray-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;